














import { mapGetters } from 'vuex';

export default {
	name: 'JobsTextTabs',

	props: {
		filter: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	data() {
		return {
			filterValue: null,
			selectedFilter: null,
		};
	},

	computed: {
		textTabItems() {
			return [
				{
					text: 'All',
					value: null,
					active: !this.filterValue,
				},
				{
					text: 'Drafts',
					value: 'Draft',
					active: this.filterValue === 'Draft',
				},
				{
					text: 'Published',
					value: 'Published',
					active: this.filterValue === 'Published',
				},
				{
					text: 'Unpublished',
					value: 'Unpublished',
					active: this.filterValue === 'Unpublished',
				},
				{
					text: 'Scheduled',
					value: 'Scheduled',
					active: this.filterValue === 'Scheduled',
				},
			];
		},

		...mapGetters('jobs', {
			currentFilters: 'getFilters',
		}),

		otherFilters() {
			return this.currentFilters?.filters.filter((i) => i.filterBy !== 'Status' && i.filterBy !== 'Scheduled') || null;
		},
	},

	watch: {
		filterValue() {
			this.selectedFilter =
				this.filterValue === 'Scheduled'
					? { filterBy: this.filterValue, filterValue: '1' }
					: { filterBy: 'Status', filterValue: this.filterValue };

			this.setFilter();
		},
	},

	methods: {
		async setFilter() {
			let filters = [];

			if (this.filterValue) {
				filters.push(JSON.parse(JSON.stringify(this.selectedFilter)));
			}

			if (this.otherFilters) {
				filters.push(...this.otherFilters);
			}

			await this.$store.dispatch('jobs/setFilters', { filters });

			await this.$store.dispatch('jobs/getFilteredCompanyJobs');
		},
	},
};
